import { Form } from "antd";
import { CustomButton } from "@Components/Button";
import { useNavigate } from "react-router-dom";
import FormItem from "@Components/FormItem/FormItem";
import AuthCard from "@Components/AuthCard";
import UnAuthHeader from "../UnAuthHeader";
import { NavigationRoutes } from "@Navigation/NavigationRoutes";
import useForgotPasswordContainer from "./useContainerForgotPassword";

const ForgotPassword = () => {
  const { form, isPending, handleSubmit, handleLogin, navigate } =
    useForgotPasswordContainer();


  return (
    <div className="flex justify-center items-center  ">
      <AuthCard
        title="Email Verification"
        description="Enter your email address to receive a verification code."
      >
        <div className="py-2 sm:py-3 ">
          <Form
            form={form}
            initialValues={{ email: null }}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <FormItem
              name="email"
              inputConfig={{
                label: "Email",
                type: "email",
                placeholder: "Enter email",
              }}
              rules={[
                { required: true, message: "Please enter your email" },
                {
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              ]}
            />

            <Form.Item className="text-center mb-6 !mt-10 sm:mt-8">
              <CustomButton
                title={"Send Code"}
                shape="round"
                type="primary"
                className="!bg-primaryGreen w-full !font-Nunito h-11 sm:h-12 !tracking-wider rounded-[12px]"
                htmlType="submit"
                isLoading={isPending}
                disabled={isPending}
              />
            </Form.Item>

            <div className="text-center mt-4 mb-4">
              <p className="!text-sm font-medium text-TitleText">
                Back to{" "}
                <span
                  className="font-semibold !text-titleText cursor-pointer hover:text-primaryGreen hover:underline transition-all"
                  onClick={() => navigate(NavigationRoutes.AUTH_ROUTES.LOGIN)}
                >
                  login
                </span>
              </p>
            </div>
          </Form>
        </div>
      </AuthCard>
    </div>
  );
};

export default ForgotPassword;
